import {
  createCycles,
  runDestroy,
  runMount,
  runPageOut,
  runPageIn,
} from "@/modules/_";

createCycles();
runPageIn();
runMount();

// modules
import { TextAnimations } from "@/modules/text-animations";

import { CardBorder } from "@/modules/card-border";
import { CoinsAnimation } from "@/modules/coins-animation";
import { Marquee } from "@/modules/marquee";
import { LogosWheel } from "@/modules/logos-wheel";

const textAnimations = new TextAnimations();
textAnimations.init();
const cardBorder = new CardBorder();
cardBorder.init();
const footerCoins = new CoinsAnimation('riveFooter', 'footerSection', -0.8, "top bottom", "bottom 20%")
footerCoins.init()
const marquee = new Marquee();
marquee.init();
const logosWheel = new LogosWheel();
logosWheel.init();

history.scrollRestoration = "manual";
window.scrollTo(0, 0);